export default __webpack_public_path__ + "static/media/next.3881e1b7.png";